"use client";

import "@/styles/globals.css";

export default function Styles() {
  return <></>;
}
